<template>
  <RevCard class="px-48 py-28">
    <RevContentBlock
      :image-props="{
        alt: '',
        src: '/img/options/pricing/price.svg',
        width: 465,
        height: 257,
      }"
      :surtitle="i18n(translations.surtitle)"
      :title="i18n(translations.title)"
    >
      <span class="body-1">
        {{ i18n(translations.description) }}
      </span>
    </RevContentBlock>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevContentBlock } from '@ds/components/ContentBlock'

import translations from './Banner.translations'

const i18n = useI18n()
</script>
